/*
 * @Description 飞书封装的相关方法
 */

import { urlParams } from '@lhb/func';
import { authenticationByLark } from '../api/common';
// import { ThirdPartyPlatformType } from './options';
import { removeCookie, removeStorage } from '@lhb/cache';
import { mapFilter } from '@/views/youth/pages/map/ts-config';


export const targetMsgPath = [
  '/expandstore/expansiontask',
  '/expandstore/approver'
];

/**
 * 飞书网页JSAPI进行鉴权
 * @param {Number} tenantId 租户id（即：登录成功后才可以调用）
 * @param {Array} jsApiList api列表 https://open.feishu.cn/document/client-docs/h5/
 */
export const apiAuthForLark = async (tenantId: number, jsApiList: any[]) => {
  const params: any = {
    url: window.location.href,
    tntId: tenantId
  };
  const res = await authenticationByLark(params);
  const { appId, timestamp, noncestr, signature } = res;
  return new Promise((resolve, reject) => {
    let configSuccessRes = {};
    window.h5sdk.config({
      appId,
      timestamp,
      nonceStr: noncestr,
      signature,
      jsApiList,
      // 鉴权成功回调
      onSuccess: (successRes: any) => {
        configSuccessRes = successRes;
      },
      // 鉴权失败回调
      onFail: (err) => {
        reject(`${JSON.stringify(err)}`);
      },
    });
    window.h5sdk.ready(() => {
      resolve(configSuccessRes);
    });
  });
};

/**
 * 场景：处理飞书环境内工作台/审批消息访问Location时401的场景
 */
export const handleInterceptInLark = () => {
  // appId是消息链接中的，appID是工作台配置的query参数（针对换绑租户之后token失效的场景，有可能是工作台打开的，有可能是消息打开的）
  const { appId, appID } = urlParams(window.location.search);
  const { href, origin } = window.location;
  const curUrl = href; // 当前页地址
  if (appId || appID) { // 飞书链接
    removeCookie('flow_token');
    removeCookie('tenantId');
    removeCookie('employeeId');
    removeStorage(mapFilter);
    removeStorage('reloadTimesTap');
    // 注意默认登录页/feishu/exemption页面使用的是大写的appID，而消息链接里服务端拼的是小写的appId.，另外需要对curUrl进行编码，在对应的免登页解码
    window.location.replace(`${origin}/feishu/exemption?appID=${appId || appID}&originUrl=${encodeURIComponent(curUrl)}`);
    return;
  }
};

